import AddSiteForm from "../Components/Sites/AddSiteForm";
import AddUserForm from "../Components/Users/AddUserForm";
import EditUserForm from "../Components/Users/EditUserForm";
import React from "react";
import { Redirect } from "react-router";
import Sites from "../Components/Sites/Sites";
import Users from "../Components/Users/Users";
import EditSiteForm from "../Components/Sites/EditSiteForm";
import EmailTemplateMain from "./../Components/Email/EmailTemplateMain";
import Patients from "../Components/Patients/Patients";
import UploadCT from "../Components/Patients/UploadCT";
import EditPatient from "../Components/Patients/EditPatient";
import crypto from "crypto";
import EmailTemplatesTable from "./../Components/Email/EmailTemplatesTable";
let role = localStorage.getItem("role");
let key = crypto.createDecipher("aes-128-cbc", "mypassword");
if (role) {
  try {
    role = key.update(localStorage.getItem("role"), "hex", "utf8");
    role += key.final("utf8");
  } catch (error) {
    console.log("error", error);
    localStorage.clear();
    window.location = "/";
  }
}
export const routeConfigList = [
  {
    title: "Sites",
    path: "/sites",
    // isVisible: role === "ADMIN" || role == "ASSISTANT" || role === "SALESREP" ||,
    isVisible: true,
  },
  {
    title: "Users",
    path: "/users",
    main: (e, props) =>
      role !== "PHYSICIAN" ? (
        <Users {...e} data={props} />
      ) : (
        <Redirect to="/" />
      ),
    isVisible: role === "ADMIN",
    // isVisible: role !== "SALESREP" ? true : false,
  },
  {
    title: "Patients",
    path: "/patients",
    isVisible:
      role === "ADMIN" ||
      role === "PHYSICIAN" ||
      role === "ASSISTANT" ||
      role === "SALESREP",
  },
  {
    title: "Email Templates",
    path: "/email-templates",
    // path: "/EmailTemps",
    isVisible: role === "ADMIN",
  },
];

export const Routes = [
  // {
  //   path: "/",
  //   exact: true,
  //   main: (e, props) => <Login2 {...e} data={props} />,
  // },
  {
    path: "/sites",
    exact: true,
    main: (e, props) => <Sites {...e} data={props} />,
    // isVisible: role === "ADMIN" || role == "ASSISTANT" || role === "SALESREP",
    isVisible: true,
  },
  {
    path: "/add-site",
    exact: true,
    main: (e, props) => <AddSiteForm {...e} data={props} />,
    isVisible: role === "ADMIN",
  },
  {
    path: "/edit-site",
    exact: true,
    main: (e, props) => <EditSiteForm {...e} data={props} />,
    isVisible: role === "ADMIN",
  },
  {
    path: "/users",
    exact: true,
    main: (e, props) => <Users {...e} data={props} />,
    isVisible: role === "ADMIN" ,
    // isVisible: true,
  },
  {
    path: "/add-user",
    exact: true,
    main: (e, props) => <AddUserForm {...e} data={props} />,
    isVisible: role === "ADMIN",
    // isVisible:true,
  },
  {
    path: "/edit-user",
    exact: true,
    main: (e, props) => <EditUserForm {...e} data={props} />,
    isVisible: role === "ADMIN",
    // isVisible: true,
  },
  {
    path: "/patients",
    exact: true,
    main: (e, props) => <Patients {...e} data={props} />,
    isVisible:
      role === "ADMIN" ||
      role === "PHYSICIAN" ||
      role === "ASSISTANT" ||
      role === "SALESREP",
  },
  {
    path: "/upload-CT",
    exact: true,
    main: (e, props) => <UploadCT {...e} data={props} />,
    isVisible:
      role === "ADMIN" ||
      role === "PHYSICIAN" ||
      role === "ASSISTANT" ||
      role === "SALESREP",
  },
  {
    path: "/edit-upload-CT",
    exact: true,
    main: (e, props) => <EditPatient {...e} data={props} />,
    isVisible:
      role === "ADMIN" ||
      role === "PHYSICIAN" ||
      role === "ASSISTANT" ||
      role === "SALESREP",
  },
  {
    path: "/EmailTemps",
    exact: true,
    main: (e, props) => <EmailTemplateMain {...e} data={props} />,
    isVisible: role === "ADMIN",
  },
  {
    path: "/email-templates",
    exact: true,
    main: (e, props) => <EmailTemplatesTable {...e} data={props} />,
    isVisible: role === "ADMIN",
  },
];
